"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.REALM_LOCAL_STORAGE_KEY = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _find = _interopRequireDefault(require("lodash/find"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _reactUse = require("react-use");
var _Box = _interopRequireDefault(require("../../Containers/Box"));
var _CardLink = _interopRequireDefault(require("./common/CardLink"));
var _HeaderButton = _interopRequireDefault(require("./common/HeaderButton"));
var _Popover = _interopRequireDefault(require("../../Tooltips/Popover"));
var _helpers = require("../../helpers");
var _excluded = ["realms", "currentRealmCode", "onRealmChange", "automationHook"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var RealmButton = (0, _styledComponents["default"])(_HeaderButton["default"]).withConfig({
  displayName: "Realm__RealmButton",
  componentId: "sc-87xpw9-0"
})(["", ""], function (props) {
  return props.triggerColor && (0, _styledComponents.css)(["border-color:", ";background-color:", ";&:hover,&:focus{border-color:", ";background-color:", ";}"], props.triggerColor, props.triggerColor, (0, _helpers.darkenSafe)(0.1, props.triggerColor), (0, _helpers.darkenSafe)(0.1, props.triggerColor));
});
var propTypes = {
  /** Realms array */
  realms: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    code: _propTypes["default"].string,
    color: _propTypes["default"].string
  })),
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string,
  /** Specifies the current realm of the logged in user */
  currentRealmCode: _propTypes["default"].string,
  /** Function that manages what happens when realm changes */
  onRealmChange: _propTypes["default"].func
};
var REALM_LOCAL_STORAGE_KEY = "realm";
exports.REALM_LOCAL_STORAGE_KEY = REALM_LOCAL_STORAGE_KEY;
var Realm = function Realm(_ref) {
  var _realms$;
  var realms = _ref.realms,
    currentRealmCode = _ref.currentRealmCode,
    onRealmChange = _ref.onRealmChange,
    automationHook = _ref.automationHook,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useLocalStorage = (0, _reactUse.useLocalStorage)(REALM_LOCAL_STORAGE_KEY, currentRealmCode || (realms === null || realms === void 0 ? void 0 : (_realms$ = realms[0]) === null || _realms$ === void 0 ? void 0 : _realms$.code)),
    _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
    savedRealmCode = _useLocalStorage2[0],
    setSavedRealmCode = _useLocalStorage2[1];
  var _ref2 = (0, _find["default"])(realms, {
      code: savedRealmCode
    }) || {},
    _ref2$color = _ref2.color,
    realmColor = _ref2$color === void 0 ? "" : _ref2$color,
    _ref2$name = _ref2.name,
    savedRealmName = _ref2$name === void 0 ? "" : _ref2$name;
  (0, _react.useEffect)(function () {
    if (savedRealmCode !== currentRealmCode) {
      setSavedRealmCode(currentRealmCode);
    }
  }, [savedRealmCode, currentRealmCode, setSavedRealmCode]);
  var handleOnRealmChange = function handleOnRealmChange(realm) {
    setSavedRealmCode(realm.code);
    onRealmChange === null || onRealmChange === void 0 ? void 0 : onRealmChange(realm);
  };
  return /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
    cardProps: {
      p: "base"
    },
    triggerW: "auto",
    align: "end",
    automationHook: automationHook,
    renderTrigger: function renderTrigger(_ref3) {
      var togglePopover = _ref3.togglePopover,
        isOpen = _ref3.isOpen;
      return /*#__PURE__*/_react["default"].createElement(RealmButton, _extends({
        triggerText: savedRealmName,
        triggerColor: realmColor,
        isOpen: isOpen,
        onClick: togglePopover
      }, other));
    }
  }, function () {
    return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
      d: "flex",
      gap: "base"
    }, realms.map(function (realm) {
      return /*#__PURE__*/_react["default"].createElement(_CardLink["default"], {
        key: realm.code,
        onClick: function onClick() {
          return handleOnRealmChange(realm);
        },
        disabled: realm.code === savedRealmCode,
        automationHook: (0, _automationHooks.getHook)(automationHook, "button_".concat(realm.code))
      }, realm.name);
    }));
  });
};
Realm.propTypes = propTypes;
var _default = Realm;
exports["default"] = _default;